// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';

class LocalizedString implements SimpleEntity {
    static fields: EntityFieldCollection = {
        languageCode: {
            displayName: 'Language',
            recordName: 'language_code',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        countryCode: {
            displayName: 'Locale Country',
            recordName: 'country_code',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        text: {
            displayName: 'Text',
            recordName: 'text',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default LocalizedString;
